import { useContext, useState } from 'react';
import { Menu, MenuItem } from '@mui/material'; // TO DO replace with DL

import { Avatar, Box } from 'design-library';

import { AuthContext } from 'common/contexts';

export function NavProfileButton() {
  const { signoutRedirectCallback } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box styles={{ alignItems: 'center', justifyContent: 'flex-end' }}>
      <Avatar size="small" onClick={(e) => handleClick(e)} />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => signoutRedirectCallback()}>Logout</MenuItem>
      </Menu>
    </Box>
  );
}
